import { render, staticRenderFns } from "./IntroductionBanner.vue?vue&type=template&id=86894624&"
import script from "./IntroductionBanner.vue?vue&type=script&lang=js&"
export * from "./IntroductionBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports